'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = exports.request = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _request = require('./request');

var _request2 = _interopRequireDefault(_request);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _event = require('./event');

var _event2 = _interopRequireDefault(_event);

var _downloadjs = require('downloadjs');

var _downloadjs2 = _interopRequireDefault(_downloadjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * 导出常用请求函数到全局，其它高级配置使用 '.request.xxx()' 
 * 或直接 import request from 'cmn-utils/lib/request';
 */
var requestConfig = _request2['default'].config;
var requestHeaders = _request2['default'].headers;
var getform = _request2['default'].getform;
var postform = _request2['default'].postform;
var send = _request2['default'].send;
var get = _request2['default'].get;
var post = _request2['default'].post;
var head = _request2['default'].head;
var del = _request2['default']['delete'];
var put = _request2['default'].put;
var jsonp = _request2['default'].jsonp;

exports.request = _request2['default'];

/**
 * 导出常用存储函数到全局，其它高级配置使用 '.store.xxx()' 
 * 或直接 import {xxx} from 'cmn-utils/lib/store'
 */

var setStore = _store2['default'].setStore;
var getStore = _store2['default'].getStore;
var removeStore = _store2['default'].removeStore;
var clearStore = _store2['default'].clearStore;

exports.store = _store2['default'];

/**
 * default export
 */

var L = (0, _extends3['default'])({
  // request api
  request: _request2['default'], requestConfig: requestConfig, requestHeaders: requestHeaders, getform: getform, postform: postform, send: send, get: get, post: post, head: head, del: del, put: put, jsonp: jsonp,
  // store api
  store: _store2['default'], setStore: setStore, getStore: getStore, removeStore: removeStore, clearStore: clearStore,
  // event api
  event: _event2['default'], on: _event.on, once: _event.once, off: _event.off, trigger: _event.trigger,
  // download
  download: _downloadjs2['default']
}, require('./utils'));

if (L.__esModule) delete L.__esModule;

exports['default'] = L;